import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment'
import { BasicSelect,ModelSelect} from 'vue-search-select';
import user_tracker from '../../../usertracker'

export default {
  name: 'setbaggingpattern',
  components: {
    BasicSelect,
    ModelSelect,
    VueElementLoading,
    Multiselect
  },
  props: [],
  data() {
    return {
      hubzoneid: '',
      listHubZoneData: [],
      routetype: {},
      routetypelist: [{
        value: 1,
        text: 'Local'
      }, {
        value: 3,
        text: 'LineHaul'
      },
      // {
      //   value: 5,
      //   text: 'BrooksNBonds'
      // }, {
      //   value: 6,
      //   text: 'Biker'
      // }
      ],
      sourceHubId: {},
      listSourceHubNameData: [],
      ConnectionID: [],
      listConnection: [],
      HubArr: [],
      destData: [],
      connectionDestList: [],
      addmodalShow: false,
      checkAllHub:false,
      totalmappedhubs: 0,
      connDestLoading:false,
      useremail:'',
      zoneLoading:'',
      sourceHubLoading:'',
      connectionLoading:'',
      modelArr: [],
      checked:[],
      userData:[],
      sourceHubIdArr:[]
    }
  },
  computed: {

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes             = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext         = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail        = JSON.parse(plaintext);
    this.useremail        = userdetail[0].email;
    this.userData = userdetail;
    this.getHubZoneData();
  },
  methods: {

    customLabel ({ text, FullConnectionName }) {
      return `${text} – ${FullConnectionName}`;
    },
   selectHub(selected){
      this.sourceHubId=selected;
      this.getConnectionListByHubIDAndConnectionType();
   },
    getConnectionListByHubIDAndConnectionType() {
      if (!this.sourceHubId ||
       !this.sourceHubId.value  || Object.keys(this.routetype).length <= 0) { return false; }

      this.connectionLoading  = 'Loading Connection Name...'
      this.listConnection     = [];
      this.ConnectionID       = [];
      this.resetHubSelection();

      this.input = {
        source: parseInt(this.sourceHubId.value),
        type: parseInt(this.routetype.value)
      }
      axios({
        'method': 'POST',
        'url': apiUrl.api_url_hubops + 'getroutemaster',
        'data': this.input,
        'headers': {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      })
      .then(result => {
        if (result.data.ResultCode == 100) {
          for (let i = 0; i < result.data.ResponseData.length; i++) {
            this.listConnection.push({
              value: result.data.ResponseData[i].ConnectionID,
              text: result.data.ResponseData[i].ConnectionName + ' ( TP' + result.data.ResponseData[i].Stoppoints.length + ' )',
              FullConnectionName: result.data.ResponseData[i].FullConnectionName
            })
          }
        } else {
          this.$alertify.error("No Connection Found!")
        }
        this.connectionLoading = '';
      }, error => {
        this.connectionLoading = '';
        this.$alertify.error("Connection API Error", "", "error");
        console.error(error);
      })
    },

    getHubZoneData() {

      this.zoneLoading = 'Loading Zone...';
      this.resetHubSelection();
      this.listConnection = [];
      this.ConnectionID   = [];
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubzone/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            let listHubZoneData = result.data.ResponseData;
            for (let i = 0; i < listHubZoneData.length; i++) {
              this.listHubZoneData.push({
                value: listHubZoneData[i].hubzoneid,
                text: listHubZoneData[i].hubzonename
              })
            }
          }
          this.zoneLoading = '';
        }, error => {
          this.zoneLoading = '';
          console.error(error);
        })
    },

    getSourceHubNameList(zoneid) {

      this.sourceHubLoading = 'Loading Hub...'
      this.listSourceHubNameData = [];
      this.sourceHubId= {};
      this.sourceHubIdArr=[];
      this.listConnection = [];
      this.ConnectionID   = [];
      this.resetHubSelection();
      this.input = ({
        hubZoneId: zoneid
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.listSourceHubNameData = result.data.ResponseData.map(i => ({ text:i.HubName +' ('+i.HubID+')', value:i.HubID, hubcode: i.HubCode }));
          }
          this.sourceHubLoading = '';
        }, error => {
          this.sourceHubLoading = '';
          console.error(error)
        })
    },

    onSubmit: function() {
      this.$validator.validateAll()
        .then((result) => {
          if (Object.keys(this.routetype).length <= 0 || Object.keys(this.sourceHubId).length <= 0 || Object.keys(this.ConnectionID).length <= 0){
            document.getElementById("route").innerHTML= (Object.keys(this.routetype).length <= 0) ? 'The Route Type field is required.':'';
            document.getElementById("source").innerHTML= (Object.keys(this.sourceHubId).length <= 0) ? 'The Source Hub Name field is required.':'';
            document.getElementById("conn").innerHTML= (Object.keys(this.ConnectionID).length <= 0) ? 'The Connection Name field is required.':'';
            return false;
          }

          if (!result) {
            console.log('errors exist', this.errors);
            return false;
          } else {
            this.getDestinationsByConnection();
          }
        }).catch(() => {
          console.log('parent search errors exist', this.errors);
        });
    },

    resetForm() {
      this.hubzoneid= '',
      this.routetype= {},
      this.sourceHubId= {},
      this.listSourceHubNameData= [],
      this.ConnectionID= [],
      this.listConnection= [],
      this.HubArr= [],
      this.modelArr= [],
      this.checked= [],
      this.destData= [],
      this.connectionDestList= [],
      this.addmodalShow= false,
      this.checkAllHub= false,
      this.totalmappedhubs= 0,
      this.zoneLoading= '',
      this.sourceHubLoading= '',
      this.connectionLoading= '',
      this.connDestLoading= false,
      document.getElementById("route").innerHTML='',
      document.getElementById("source").innerHTML='',
      document.getElementById("conn").innerHTML='',
      this.$validator.reset();
      this.sourceHubIdArr=[];
    },


    closeStatusModal() {
      this.addmodalShow = false
    },

    getDestinationsByConnection() {
      if (Object.keys(this.ConnectionID).length <= 0 || Object.keys(this.sourceHubId).length <= 0) { return false; }

      this.connDestLoading    = true;
      this.destData           = [];
      this.modelArr           = [];
      this.HubArr             = [];
      this.connectionDestList = [];
      this.totalmappedhubs    = 0;
      this.checkAllHub        = false;
      this.checked            = [];
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + "fetchConnectionHubDetailsByConnectionId_V1?connectionId="+this.ConnectionID.value,
          headers: {
            'Authorization': "authkey xB84JJ89Hd25"
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            let j=0; let list=[]; let dlist=[];
            let hData = result.data.ResponseData;
            for (var i = 0; i < hData.length; i++) {
              if(j<4){
                list.push({
                  hubId:hData[i].hubid,
                  hubName:hData[i].hubname
                });
              }else{
                dlist.push(list);
                list=[]
                list.push({
                  hubId:hData[i].hubid,
                  hubName:hData[i].hubname
                });
                j=0;
              }
              j++;

              if(hData[i].isbaggingpattern==true){
                this.modelArr.indexOf(hData[i].hubid) === -1 ? this.modelArr.push(hData[i].hubid):'';
                this.checked[hData[i].hubid] = true;
              }
              this.destData.push({
                hubId:hData[i].hubid,
                hubName:hData[i].hubname
              });
            }
            dlist.push(list);
            this.connectionDestList = dlist;

            this.totalmappedhubs  = result.data.TotalBaggingAllocCount;
            if(this.modelArr.length == this.destData.length) this.checkAllHub = true;
          }else{
            this.$alertify.error(result.data.ReturnMessage, "", "error");
          }
          this.connDestLoading=false;
        }, error => {
          this.connDestLoading=false;
          console.error(error)
        })
    },

    checkHub() {
      if(typeof InstallTrigger !== 'undefined' == true){ this.checkAllHub = !this.checkAllHub; }
      this.modelArr = [];

      if (this.checkAllHub) {
        for (var i = 0; i < this.destData.length; i++) {
          this.checked[this.destData[i].hubId]=true;
        }

        this.modelArr = [...new Set(this.destData.map(a => a.hubId))];
      }else{
         this.checked=[];
      }
    },

    updateCheckDest(event){
     this.checked[event.target.id] = event.target.checked;

     if(event.target.checked==false){
       this.modelArr = this.modelArr.filter(el => el != event.target.id)

     }else{
       this.modelArr.indexOf(event.target.id) === -1 ? this.modelArr.push(parseInt(event.target.id)):'';
     }

     this.checkAllHub = (this.destData.length === this.modelArr.length) ? true : false;
	 },

    onSubmitHubSearch: function(elem) {
     this.$validator.validateAll('hub').then((result) => {

       if (Object.keys(this.routetype).length <= 0 || Object.keys(this.sourceHubId).length <= 0 || Object.keys(this.ConnectionID).length <= 0){
         document.getElementById("route").innerHTML= (Object.keys(this.routetype).length <= 0) ? 'The Route Type field is required.':'';
         document.getElementById("source").innerHTML= (Object.keys(this.sourceHubId).length <= 0) ? 'The Source Hub Name field is required.':'';
         document.getElementById("conn").innerHTML= (Object.keys(this.ConnectionID).length <= 0) ? 'The Connection Name field is required.':'';
         return false;
       }

       if (result) {
         this.getDestinationsByConnection()
       }else{
         console.log('errors exist');
         return false;
       }
     }).catch(() => {});
   },

    onSubmitHub: function(elem) {
     this.$validator.validateAll('hubsave').then((result) => {
       if (result) {
         if (Object.keys(this.ConnectionID).length <= 0 || Object.keys(this.sourceHubId).length <= 0 || this.modelArr.length <= 0) {
           this.$alertify.error('Destination selection or connection should not be empty!'); return false;
         }else{
           this.addmodalShow = true
         }
       }else{
         return false;
       }
     }).catch(() => {});
   },

    mapMultipleHubsToConnection() {
     this.connDestLoading = true;
     this.input = ({
      connectionid: this.ConnectionID.value,
      hubids: this.modelArr,
      createdby: this.useremail
     })
     axios({
         method: 'PUT',
         'url': apiUrl.api_url_hubops + "allocateDeallocateBaggingPattern_V1",
         'data': this.input,
         headers: {
           'Authorization': "authkey xB84JJ89Hd25"
         }
       })
       .then(result => {
         if (result.data.ResultCode == 100) {
           this.$alert(result.data.ReturnMessage, "", "success");
           user_tracker.checkUserIP(this.userData[0], "setbaggingpattern", this.$route.path , this.input);
           this.getDestinationsByConnection();
         } else {
           this.$alert(result.data.ReturnMessage, "", "error");
         }
         this.connDestLoading = false;
       }, error => {
         this.connDestLoading = false;
         console.error(error)
       })
   },
    takeAction() {
     this.mapMultipleHubsToConnection();
   },

   resetHubSelection() {
    this.checkAllHub= false,
    this.connectionDestList= [],
    this.totalmappedhubs= 0,
    this.modelArr= [],
    this.checked= [],
    this.connDestLoading= false
  },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/setbaggingpattern/setbaggingpattern.component.js